import { render, staticRenderFns } from "./exchangeOrderJoin.vue?vue&type=template&id=725d04f4&scoped=true&"
import script from "./exchangeOrderJoin.vue?vue&type=script&lang=js&"
export * from "./exchangeOrderJoin.vue?vue&type=script&lang=js&"
import style0 from "./exchangeOrderJoin.vue?vue&type=style&index=0&id=725d04f4&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "725d04f4",
  null
  
)

export default component.exports